import { Stack } from '@mui/material';
import logo from '../assets/images/logo.png'

const Loader = () => {

    return (
        <>
            <Stack className="auth-wrapper" height={"100%"} justifyContent="center" alignItems="center">
                <img src={logo} alt="Axium logo" width={170} style={{ animation: "floating 2s infinite" }} />
            </Stack>
        </>
    );

}

export default Loader;